import './bbutil'
import BBIFrame from './BBIFrame'
import WidgetCategory from '../../WidgetCategory';

class BBNOML extends BBIFrame {
  getUrl = () => `/${window.bbFolderName}/noml.html`

  constructor() {
    super()

    this.scrolling = 'no'
    this.noEvents = false
  }

  static getDescription() {
    return {
      name: 'BBNOML',
      component: BBNOML,
      label: 'UML Diagram NOML (BBNOML) (experimental)',
      category: WidgetCategory.experimental,
      variables: [
        {
          name: 'data',
          type: 'text',
          label: 'noml input',
        },
      ],
    }
  }
}
export default BBNOML
